
import InfoPageLayout from "./InfoPageLayout";
import ContentSection from "./ContentSection";

const policyData = [
  {
    type: "p",
    content:
      'Last updated: [Date]. At Xenford ("we", "our", "us"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our TimeWise application (the "Service").',
  },
  { type: "h2", content: "1. Information We Collect" },
  {
    type: "p",
    content:
      "We may collect information about you in a variety of ways. The information we may collect via the Service includes:",
  },
  {
    type: "ul",
    items: [
      "Personal Data: Personally identifiable information, such as your name, mobile number, and email address, that you voluntarily give to us when you register with the Service.",
      "Geolocation Information: We may request access or permission to and track location-based information from your mobile device to provide location-based services. You can change our access or permissions in your device’s settings.",
      "Data from Events and Appointments: Information you provide when creating events, appointments, or responding to invites, including descriptions, times, and responses to questionnaires.",
    ],
  },
  { type: "h2", content: "2. How We Use Your Information" },
  {
    type: "p",
    content:
      "Having accurate information permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Service to:",
  },
  {
    type: "ul",
    items: [
      "Create and manage your account.",
      "Facilitate the core scheduling and invitation features of the Service.",
      "Notify you of updates to your schedule or new invitations.",
      "Monitor and analyze usage and trends to improve your experience with the Service.",
    ],
  },
  { type: "h2", content: "3. Data Security" },
  {
    type: "p",
    content:
      "We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.",
  },
];

const PrivacyPolicy = () => {
  return (
    <InfoPageLayout
      title="Privacy Policy"
      subtitle="Your data is yours. We are committed to its security and confidentiality."
    >
      <ContentSection data={policyData} />
    </InfoPageLayout>
  );
};

export default PrivacyPolicy;
